import { useState } from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { adminApi } from "../../services/api";
import AdminPanel from "../../components/admin/AdminPanel";
import AdminTable from "../../components/admin/AdminTable";
import AdminStatus from "../../components/admin/AdminStatus";
import useAdminData from "../../components/admin/useAdminData";
import { unwrap } from "../../components/admin/adminFormat";
import Button from "../../components/Button";
import Input from "../../components/Input";

export default function Settings() {
  const { t } = useTranslation();
  const { data, setData, loading } = useAdminData(async () => unwrap(await adminApi.getSettings()), []);
  const items = data || [];
  const [editing, setEditing] = useState(null);

  const save = async () => {
    try {
      const updated = unwrap(await adminApi.updateSettings({
        ...editing,
        zones: typeof editing.zones === "string" ? editing.zones.split(",").map((zone) => zone.trim()).filter(Boolean) : editing.zones,
      }));
      setData(items.map((item) => (item.countryCode === updated.countryCode ? updated : item)));
      setEditing(null);
      toast.success(t("admin.settings_saved"));
    } catch (error) {
      toast.error(error.response?.data?.message || t("admin.request_error"));
    }
  };

  return (
    <AdminPanel>
      {loading ? t("common.loading") : (
        <>
          {editing && (
            <div style={{ background: "#EFF6FF", borderRadius: 12, padding: 16, marginBottom: 16 }}>
              <Input label={t("admin.zones")} value={Array.isArray(editing.zones) ? editing.zones.join(", ") : editing.zones} onChange={(event) => setEditing({ ...editing, zones: event.target.value })} />
              <Input label={t("admin.notify_threshold")} type="number" value={editing.minScoreNotify} onChange={(event) => setEditing({ ...editing, minScoreNotify: Number(event.target.value) })} />
              <Input label={t("admin.strong_threshold")} type="number" value={editing.minScoreStrong} onChange={(event) => setEditing({ ...editing, minScoreStrong: Number(event.target.value) })} />
              <Button onClick={save}>{t("admin.save")}</Button>
            </div>
          )}
          <AdminTable
            t={t}
            headers={[t("admin.country"), t("admin.zones"), t("admin.notify_threshold"), t("admin.strong_threshold"), t("admin.status"), t("admin.action")]}
            rows={items.map((item) => [
              item.countryCode,
              item.zones?.join(", ") || "—",
              item.minScoreNotify,
              item.minScoreStrong,
              <AdminStatus key="s" active={item.active} t={t} />,
              <Button key="b" size="sm" onClick={() => setEditing({ ...item })}>{t("admin.edit")}</Button>,
            ])}
          />
        </>
      )}
    </AdminPanel>
  );
}
